import { useReadLocalStorage } from 'usehooks-ts'
import { AttributionRequest } from 'lib/api/pointOfSale'

export default function useTrackingTag(): AttributionRequest {
  const tag = useReadLocalStorage<any>('tag')
  var params = {}

  if (!tag) return params

  if (tag.params.gclid) {
    params = { ...params, click_id: tag.params.gclid.value }
  }

  if (tag.params.msclkid) {
    params = { ...params, click_id: tag.params.msclkid.value }
  }

  if (tag.params.utm) {
    params = { ...params, ...tag.params.utm }
  }

  if (tag.params.affiliate) {
    params = { ...params, ...tag.params.affiliate }
  }

  return params
}
